const css = require('./mobile.scss');
const {toggleClass, wrapLinkWithBiEvent, parseURI} = require('../../utils');
const {domains} = require('../../data/constants.json');
const bi = require('../../bi');
const radioInputName = `marketing-header-and-footer-state-${Math.random().toString(36).substr(2)}`;

module.exports = {
  radioInputName,

  bindStateChangeListener() {
    document.querySelectorAll(`input[name="${radioInputName}"]`)
      .forEach(element => element.addEventListener('change', event => {
        const closed = event.target.id === css.allClosed;
        if (!closed) {
          bi.mobile.log({evid: 202});
        }
        toggleClass(document.body, css.marketingHeaderAndFooterFixedBody, !closed);
      }
    ));
  },

  markCurrentMenuItem() {
    const link = document.querySelector(`.${css.section}:first-child .${css.menuItem} a[href$="${location.pathname}"]`);
    if (link) {
      toggleClass(link, css.active, true);
    }
  },

  bindLinkClicks() {
    document
      .querySelectorAll(`.${css.section}:first-child .${css.menuItem} a`)
      .forEach(link => wrapLinkWithBiEvent(bi.mobile, link, 203, link => {
        const uri = parseURI(link.href);
        const name = uri.hostname === domains.wix ? uri.pathname === '/' ? 'wix' : uri.pathname.substr(1) : uri.hostname;
        return {name};
      }));

    const signupLink = document.querySelector(`.${css.section}:first-child .${css.sectionHeader} a[rel=login]`);
    if (signupLink) {
      wrapLinkWithBiEvent(bi.mobile, signupLink, 202);
    }
  },

  preventSafariBackButtonCache() {
    if (navigator.platform === 'iPhone' && navigator.appVersion.indefOx('Safari') >= 0) {
      window.addEventListener('onpageshow',
        event => event.persisted ? document.querySelector(`input[name="${radioInputName}"]`).click() : undefined);
    }
  }
};



// WEBPACK FOOTER //
// ./templates/header/mobileUtils.js